'use strict';

/* global $ */

import ValidateJs from './../../vendor/jquery.validate';

$.validator.addMethod(
    'strictEmail',
    function (value, element) {
        // allow any non-whitespace characters as the host part
        /* eslint-disable */
        return this.optional(element) || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
        /* eslint-enable */
    },
    'Merci de renseigner un email valide.'
);

$.validator.addMethod(
    'dateFormat',
    function (value, element) {
        var check = false;
        var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
        if (re.test(value)) {
            var adata = value.split('/');
            var dd = parseInt(adata[0], 10);
            var mm = parseInt(adata[1], 10);
            var yyyy = parseInt(adata[2], 10);
            var xdata = new Date(yyyy, mm - 1, dd);
            if ((xdata.getFullYear() === yyyy) && (xdata.getMonth() === mm - 1) && (xdata.getDate() === dd)) {
                check = true;
            } else {
                check = false;
            }
        } else {
            check = false;
        }
        return this.optional(element) || check;
    },
    'Merci de renseigner une date valide au format JJ/MM/AAAA'
);



// WEBPACK FOOTER //
// ./front/js/modules/forms/_validateRules.js